import React, { useCallback, useRef } from 'react';

import useOnClickOutside from '_hooks/useOnClickOutside';

import { useChatContext } from '_modules/chat/hooks/useContext';

import PanelContent from './content';
import PanelFooter from './footer';
import PanelHeader from './header';
import { StyledPanel } from './style';

const Panel = () => {
  const { dispatch } = useChatContext();
  const ref = useRef<HTMLDivElement>(null);

  const onClose = useCallback(() => dispatch({ type: 'close' }), [dispatch]);

  useOnClickOutside(ref, onClose);

  return (
    <StyledPanel ref={ref}>
      <PanelHeader />
      <PanelContent />
      <PanelFooter />
    </StyledPanel>
  );
};

export default Panel;
